import request from 'superagent';
import _ from 'lodash';
import * as constants from '../../constants/caseLookupConstants';
import * as errorAction from './errorAction';
import actualRegions from '../../data/regions';
import regions from '../../data/courts';


const requestCaseLookupSearchResults = params => ({
  type: constants.REQUEST_CASE_DATA_OF_CASE_LOOKUP,
  params,
});

const receiveCaseLookupSearchResults = response => ({
  type: constants.RECEIVE_CASE_DATA_OF_CASE_LOOKUP,
  facets: response.facets,
  contents: response.contents,
  pages: response.pages,
});

const onSuccess = dispatch => function (response) {
  return dispatch(receiveCaseLookupSearchResults(response.body));
};

const courtSuffixes = [
  'bke',
  'btest',
  'btrain',
  'bap',
  'baptest',
  'baptrain',
  'cae',
  'caetest',
  'caetrain',
  'fc',
  'dce',
  'dtest',
  'dtrain',
  'dea',   // Ohio Northern District Court(asbestos) ?
  'fce',
  'test',
];

export function stripSuffix(courtName) {
  if (courtName === 'caedce' || courtName === 'caebke') {
    return courtName.substring(0, 3);
  }

  return courtSuffixes.reduce((accum, next) => {
    const segments = courtName.split(next);
    if (segments.length > 1) {
      return segments[0];
    }
    return accum;
  }, courtName);
}

export const partySearch = (query, searchType, searchValue) => function (dispatch) {
  dispatch(requestCaseLookupSearchResults(query));

  let courts = '';
  let courtCodes = '';

  const { court_name, court_code } = query;

  if (!court_code && court_name && court_name.includes(',')) {
    delete query.court_name;
    courts = court_name.split(',').reduce((accum, next, idx) => {
      const b = (idx === 0)
        ? `court_name[]=${next}`
        : `&court_name[]=${next}`
      return accum += b;
    }, '');

    courts = encodeURI(courts);
  }

  if (court_code) {
    if (court_code.includes(',')) {
      courtCodes = court_code.split(',').reduce((accum, next) => {
        // actual regions are uppercase
        if (next === next.toUpperCase()) {
          const region = (next === 'COF')
            ? { value: 'COF', label: 'Federal Claims' }
            : _.find(actualRegions, { value: next  });

          const case_type = (query.case_type === 'civil' || query.case_type === 'criminal')
            ? 'district'
            : query.case_type;

          const courtsInRegion = regions.filter((p) => {
            const courtName = p.name.toUpperCase();
            const regionName = region.label.toUpperCase();
            return p.type === case_type && courtName.includes(regionName);
          });

          return accum += courtsInRegion.reduce((ac, ne) => {
            const n = stripSuffix(ne.code);
            return ac += `&court_code[]=${n}`;
          }, '');
        }

        const n = stripSuffix(next);
        return accum += `&court_code[]=${n}`;
      }, '');
      delete query.court_code;
      courtCodes = encodeURI(courtCodes);
    } else {
      if (court_code === court_code.toUpperCase()) {
        delete query.court_code;
        const region = (court_code === 'COF')
          ? { value: 'COF', label: 'Federal Claims' }
          : _.find(actualRegions, { value: court_code });

        const case_type = (query.case_type === 'civil' || query.case_type === 'criminal')
          ? 'district'
          : query.case_type;

        const courtsInRegion = regions.filter((p) => {
          // case_type is empty on All tab, so match all
          const sameCaseType = p.type === (case_type || p.type);
          const courtName = p.name.toUpperCase();
          const regionName = region.label.toUpperCase();

          return sameCaseType && courtName.includes(regionName);
        });
        courtCodes = encodeURI(courtsInRegion.reduce((ac, ne) => {
          const n = stripSuffix(ne.code);
          return ac += `&court_code[]=${n}`;
        }, ''));
      } else {
        query.court_code = stripSuffix(court_code);
      }
    }
  }

  return request
    .get(`/filings/json/${searchType}/${searchValue}`)
    .query(query)
    .query(courts + courtCodes)
    .set('Accept', 'application/json')
    .set('Content-Type', 'application/json')
    .then(onSuccess(dispatch), errorAction.onFailure(dispatch));
};

export const updateFilter = filter => ({
  type: constants.UPDATE_FILTERS_OF_CASE_DATA_OF_CASE_LOOKUP,
  filter,
});

export const clearAllFilter = () => ({
  type: constants.CLEAR_ALL_FILTERS_OF_CASE_LOOKUP,
});



/** WEBPACK FOOTER **
 ** ./src/redux/actions/caseLookupSearchAction.js
 **/